import { ReactComponent as Spinner } from "assets/images/spinner-s.svg"
import imgRating from "assets/images/v71/ab/rating.webp"
import imgPreview from "assets/images/v71/ab/preview.webp"
import imgReviews from "assets/images/v71/ab/reviews.webp"

import imgHeaderControl from "assets/images/v71/ab/header-anonymous-dating.webp"

import imgHeaderDatingCurious from "assets/images/v71/ab/header-dating-for-the-curious.webp"
import imgHeaderDatingDifferent from "assets/images/v71/ab/header-dating-made-different.webp"
import imgHeaderDatingIntention from "assets/images/v71/ab/header-dating-with-intention.webp"
import imgHeaderDiscreet from "assets/images/v71/ab/header-discreet.webp"
import imgHeaderHonest from "assets/images/v71/ab/header-honest-dating-app.webp"
import imgHeaderIntentional from "assets/images/v71/ab/header-intentional-dating.webp"
import imgHeaderOpenMinded from "assets/images/v71/ab/header-open-minded.webp"
import imgHeaderUnhinged from "assets/images/v71/ab/header-unhinged-dating.webp"

import { generateAppsFlyerLink } from "lib/common"
import { useEffect, useState } from "react"
import { amplitudeClient, sendAmplitudeEvent } from "lib/amplitude"
import { trackMetaEvent } from "lib/meta"
import { trackSnapchatClick } from "lib/snapchat"
import { sendGoogleClickConversion } from "lib/google"
import { twMerge } from "tailwind-merge"

type StorePageProps = {
  surveyId: string
  staticVariantName?: VariantNameUnion
}

type VariantNameUnion =
  | "anonymous_dating_app"
  | "dating_for_the_curious"
  | "dating_made_different"
  | "dating_with_intention"
  | "discreet_dating_app"
  | "honest_dating_app"
  | "intentional_dating_app"
  | "open_minded_dating_app"
  | "unhinged_dating"

const titleVariants: Record<VariantNameUnion, string> = {
  anonymous_dating_app: imgHeaderControl,
  dating_for_the_curious: imgHeaderDatingCurious,
  dating_made_different: imgHeaderDatingDifferent,
  dating_with_intention: imgHeaderDatingIntention,
  discreet_dating_app: imgHeaderDiscreet,
  honest_dating_app: imgHeaderHonest,
  intentional_dating_app: imgHeaderIntentional,
  open_minded_dating_app: imgHeaderOpenMinded,
  unhinged_dating: imgHeaderUnhinged,
}

const experimentName = "web_funnels_v71_headline_exp"

export function StorePageAB(props: StorePageProps) {
  const [isLoaded, setIsLoaded] = useState(false)
  const [variant, setVariant] = useState<VariantNameUnion | null>(null)

  const titleImg =
    variant && variant in titleVariants
      ? titleVariants[variant]
      : titleVariants.anonymous_dating_app

  const onButtonClick = () => {
    trackMetaEvent("Lead")
    trackSnapchatClick()
    sendGoogleClickConversion(() =>
      sendAmplitudeEvent(
        "onboarding_cta_clicked",
        {
          onboarding: props.surveyId,
        },
        () => {
          location.assign(
            generateAppsFlyerLink(
              props.surveyId,
              false,
              variant && !props.staticVariantName
                ? {
                    expName: experimentName,
                    variantName: variant,
                  }
                : undefined,
            ),
          )
        },
      ),
    )
  }

  useEffect(() => {
    sendAmplitudeEvent("onboarding_started", {
      onboarding: props.surveyId,
    })

    const fetchVariant = async () => {
      try {
        await amplitudeClient.fetchExperimentOptions([experimentName])
        const variant =
          await amplitudeClient.fetchExperimentVariant(experimentName)
        if (variant?.value) {
          setVariant(variant.value as VariantNameUnion)
        }
      } catch {
      } finally {
        setIsLoaded(true)
      }
    }

    if (props.staticVariantName) {
      setVariant(props.staticVariantName)
      setIsLoaded(true)
    } else {
      fetchVariant()
    }
  }, [])

  if (!isLoaded) {
    return (
      <div className="max-w-[450px] mx-auto pt-[72px] px-4 pb-10 flex items-center justify-center h-full">
        <Spinner className="animate-spin text-black" />
      </div>
    )
  }

  return (
    <div className="max-w-[450px] mx-auto pt-[72px] px-6 pb-2">
      <a onClick={onButtonClick} className={twMerge("cursor-pointer")}>
        <img src={titleImg} />
      </a>
      <img src={imgRating} />
      <img src={imgPreview} />
      <img src={imgReviews} />
    </div>
  )
}
